export const VIEW = {
  ASSESSMENT: "assessment",
  RESULTS: "results",
  RESULT_DETAIL: "resultDetail",
  MATERIAL_DETAIL_VIEW: "materialDetailView",
};

export const FIRST_QUESTION = {
  question: "Select goal of care",
  description: "",
  options: [
    { option: "Treatment", description: "" },
    { option: "Prevention", description: "" },
    { option: "Incontinence", description: "" },
  ],
};

export const mapApiQuestion = (apiQuestion) => ({
  question: apiQuestion.question,
  description: apiQuestion.description,
  options: apiQuestion.answer,
});

export const TABS = {
  FORMULARY: "formulary",
  NON_FORMULARY: "nonFormulary",
};

export const mapToResource = (item) => ({
  key: item.name,
  icon: item.image,
  label: `${item.name} (${item.materialCount})`,
  materialNumber: item.materialNumber,
  materialCount: item.materialCount,
});

export const DISCLAIMER_TEXT = (
  <div>
    <p>
      *This guide is intended for use by clinicians in the United States. Product options are generated based on the application, preferences and
      wound characteristics selected. Other Medline products may also be suitable/available. It is up to each clinician to assess whether any product
      will meet their objectives. Any product identified through this guide is not intended to promote compatibility or convey combined use unless
      expressly indicated, or intended to substitute for clinicians’ clinical judgment.
    </p>

    <p>
      **Medline does not make any claims that its products prevent, treat, or reduce the incidence of infection. For specific Medline products, please
      refer to the Instructions for Use.
    </p>

    <p>Please contact your local Medline representative for product support and availability/any shipping restrictions.</p>

    <p>
      NOTE: Specific indications, warnings, precautions, and safety information exist for all Medline products and therapies. Before the use of any
      medical device, it is important for the provider to consult the treating physician and read and understand all Instructions for Use, including
      Safety Information, Application Instructions, and Therapy Device Instructions.
    </p>
  </div>
);

export const getModalHeading = (view, detailTitle) => {
  switch (view) {
    case VIEW.RESULTS:
      return "Product Recommendation";
    case VIEW.RESULT_DETAIL:
    case VIEW.MATERIAL_DETAIL_VIEW:
      return detailTitle;
    case VIEW.ASSESSMENT:
    default:
      return "Product Selector";
  }
};
